import authorizedAxios from "../../helpers/authorizedAxios";

export const SET_INVENTORY_INSIGHTS = "SET_INVENTORY_INSIGHTS";
export const SET_INVENTORY_INSIGHTS_LOADING = "SET_INVENTORY_INSIGHTS_LOADING";
export const SET_INVENTORY_INSIGHTS_ERROR = "SET_INVENTORY_INSIGHTS_ERROR";

export const fetchInventoryInsights = (params = {}) => {
  return async (dispatch) => {
    dispatch({ type: SET_INVENTORY_INSIGHTS_LOADING, status: true });

    try {
      const response = await authorizedAxios.get("/inventory-insights", { params });
      dispatch({
        type: SET_INVENTORY_INSIGHTS,
        data: response?.data?.data || null,
      });
      return response?.data?.data || null;
    } catch (error) {
      dispatch({
        type: SET_INVENTORY_INSIGHTS_ERROR,
        error: error?.response?.data?.message || "Gagal mengambil inventory insight.",
      });
      return null;
    } finally {
      dispatch({ type: SET_INVENTORY_INSIGHTS_LOADING, status: false });
    }
  };
};
